import homePage from '@/components/pages/index'
import gameNew from '@/components/pages/gameNew'
import life from '@/components/pages/life'
import introduce from '@/components/pages/introduce'
import dynamic from '@/components/pages/dynamic'

export default [
    {
        path: '/',
        label: '首页',
        key: 'index',
        component: homePage
    },
    {
        path: '/introduce',
        label: '贝塔简介',
        key: 'introduce',
        component: introduce,
        children: [
            {
                path: '/introduce?active=intro1',
                key: 'intro1',
                label: '公司简介',
            },
            {
                path: '/introduce?active=intro2',
                key: 'intro2',
                label: '愿景使命',
            },
            {
                path: '/introduce?active=intro3',
                key: 'intro3',
                label: '核心价值&工作理念',
            },
            {
                path: '/introduce?active=intro4',
                key: 'intro4',
                label: '我们的office',
            }
        ]
    },
    {
        path: '/game',
        label: '贝塔游戏',
        key: 'game',
        component: gameNew
    },
    {
        path: '/publish ',
        label: '贝塔发行',
        key: 'publish',
    },
    {
        path: '/life',
        label: '贝塔生活',
        key: 'life',
        component: life
    },
    {
        path: '/dynamic',
        label: '贝塔动态',
        key: 'dynamic',
        component: dynamic
    },
    {
        path: '/joinus',
        label: '加入我们',
        key: 'joinus'
    }
]



// WEBPACK FOOTER //
// ./src/router/routerLists.js